import { toBoard } from './mappers/board';
import { toError } from './parsers';
export function initSource(settings, http) {
  function getBoards(sourceId, options) {
    options = options || {};
    const [idOnly] = sourceId.split('/');
    return http.get(`${settings.apiUrl}/v3/boards/source/${idOnly}`, null, {
      withCredentials: true,
      headers: options.headers || {}
    }).then(response => ({
      ...response,
      data: response.data.items.map(toBoard)
    })).catch(toError);
  }
  return {
    getBoards
  };
}